<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/procurement-management/parent-account-codes"
          ></back-button>
          Add Owner Account Code
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-6 col-sm-6 col-md-6 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/procurement-management/parent-account-codes`"
              >Owner Account Codes</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Date</label>
              <div class="col-sm-10">
                <my-datepicker
                  :date.sync="form.date"
                  placeholder="Enter Date"
                ></my-datepicker>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Owner</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.owner_id"
                  :suggestions="owners"
                  placeholder="Select owner"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Owner</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.parent_id"
                  :suggestions="parents"
                  placeholder="Select parent"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Account Name</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.account_name"
                  class="form-control"
                  autocomplete="off"
                  placeholder="Account Name"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Account Code</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.account_code"
                  class="form-control"
                  placeholder="Account Code"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Classification</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.classification_id"
                  :suggestions="classifications"
                  placeholder="Select classification"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Account Head</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.account_head_id"
                  :suggestions="accountHeads"
                  placeholder="Select account head"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Description</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.description"
                  class="form-control"
                  placeholder="Description"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label"
                >Is Dispaly in Vessel</label
              >
              <div class="col-sm-10">
                <div class="form-check form-switch mb-2">
                  <input
                    type="checkbox"
                    v-model="form.is_display_in_vessel"
                    class="form-check-input"
                    id="formSwitch1"
                  />
                </div>
              </div>
            </div>
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";

export default {
  name: "OwnerAccountCodeGroupCreate",
  data() {
    return {
      form: {
        owner_id: "",
        parent_id: "",
        classification_id: "",
        account_head_id: "",
        is_display_in_vessel: true,
      },
      owners: [],
      parents: [],
      classifications: [],
      accountHeads: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("owner_account_codes/masters");
      masters = masters.data;
      masters.owners.forEach((owner) => {
        this.owners.push({
          id: owner.id,
          name: owner.name,
        });
      });
      masters.parents.forEach((parent) => {
        this.parents.push({
          id: parent.id,
          name: parent.name,
        });
      });
      masters.classifications.forEach((classification) => {
        this.classifications.push({
          id: classification.id,
          name: classification.name,
        });
      });
      masters.accountHeads.forEach((account_head) => {
        this.accountHeads.push({
          id: account_head.id,
          name: account_head.name,
        });
      });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/owner_account_codes", this.form);
        this.isLoading = false;
        this.$router.push("/procurement-management/owner-account-codes");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
